<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto"
        type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Navbar</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<maced-navbar id="Test Id" [title]="title" [subtitle]="subtitle" [backUrl]="backUrl" [links]="links"
  [hamburgerAriaLabel]="hamburgerAriaLabel" [closeButtonAriaLabel]="closeButtonAriaLabel"
  [backButtonAriaLabel]="backButtonAriaLabel"></maced-navbar>

<br>

<maced-navbar id="ID de prueba" [title]="titleSpanish" [subtitle]="subtitleSpanish" [backUrl]="backUrl" [links]="links"
  [hamburgerAriaLabel]="hamburgerAriaLabelInSpanish" [closeButtonAriaLabel]="closeButtonAriaLabelInSpanish"
  [backButtonAriaLabel]="backButtonAriaLabelInSpanish">
</maced-navbar>

<br>

<maced-navbar id="टेस्ट आईडी" [title]="titleHindi" [subtitle]="subtitleHindi" [backUrl]="backUrl" [links]="links"
  [hamburgerAriaLabel]="hamburgerAriaLabelInHindi" [closeButtonAriaLabel]="closeButtonAriaLabelInHindi"
  [backButtonAriaLabel]="backButtonAriaLabelInHindi">
</maced-navbar>